import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    list: [],
    isLoaded: false,
    selected: {}
};

const availableAppointmentTimes = createSlice({
    name: "available",
    initialState,
    reducers: {
        setAvailableAppointmentTimes: (state, { payload }) =>
        {
            state.list = payload;
            state.isLoaded = true;
        },
        addAvailableAppointmentTimesToList: (state, { payload }) =>
        {
            state.list = [...state.list, payload];
        },
        updateAvailableAppointmentTimesList: (state, { payload }) =>
        {
            state.list = state.list.map(item => item.id === payload.id ? payload : item);
        },
        removeAvailableAppointmentTimesFromList: (state, { payload }) =>
        {
            state.list = state.list.filter(item => item.id !== payload.id)
        },
        setSelectedAvailableAppointmentTimes: (state, { payload }) =>
        {
            state.selected = payload;
        },
        clearSelectedAvailableAppointemntTimes: (state, { payload }) =>
        {
            state.selected = {}
        }
    }
})

export const {
    setAvailableAppointmentTimes,
    addAvailableAppointmentTimesToList,
    updateAvailableAppointmentTimesList,
    removeAvailableAppointmentTimesFromList,
    setSelectedAvailableAppointmentTimes,
    clearSelectedAvailableAppointemntTimes
} = availableAppointmentTimes.actions;
export default availableAppointmentTimes.reducer;